// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"835":"5608a28f","940":"10ab63fb"}[chunkId] + ".css";
};